import {ThemeMode} from "./tokens.ts";

/** localStorage key holding the persisted theme choice; the single source for reader and writer. */
export const THEME_MODE_STORAGE_KEY = "transferify.theme-mode";

/**
 * Pure precedence logic for the initial theme mode, decided from the two RAW inputs the browser can
 * hand us: the persisted localStorage value (may be null, or garbage a user typed) and the OS
 * `prefers-color-scheme: dark` media match.
 *
 * Precedence: an explicit valid stored choice ("light"/"dark") always wins; otherwise fall back to
 * the OS preference; any other stored value (unset/garbage) resolves to "light".
 *
 * Deliberately dependency-free (no `window`/`localStorage` access) so it is trivially unit-testable
 * and — crucially — so the pre-hydration inline `<head>` script can reuse this exact decision. That
 * script runs before any JS bundle loads (to kill the dark-mode white flash, ui#144), so it cannot
 * import at runtime; instead `themeStamp.ts` SERIALIZES this function into the inline bootstrap at
 * build time, so the two share one implementation and cannot drift (ui#365).
 */
export function resolveInitialMode(storedValue: string | null, prefersDark: boolean): ThemeMode {
	if (storedValue === "light" || storedValue === "dark") {
		return storedValue;
	}
	return prefersDark ? "dark" : "light";
}
